export default __webpack_public_path__ + "static/media/93_mobile.ffc86524.jpg";